(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ratt-featured-bundles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ratt-featured').forEach(function (s) {
    var row = s.querySelector('.ratt-grid');
    if (!row) return;
    var step = function (dir) { row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); };
    var p = s.querySelector('[data-ratt-fprev]'); var n = s.querySelector('[data-ratt-fnext]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratt-shelf"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ratt-shelf').forEach(function (sec) {
    var btns = sec.querySelectorAll('[data-ratt-filter]');
    var grid = sec.querySelector('[data-ratt-shelf]');
    if (!grid) return;
    var items = grid.querySelectorAll(':scope > li');
    var original = [].slice.call(items);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-ratt-filter');
        btns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (f === 'bestsellers') {
          var tops = original.filter(function (li) {
            return (li.getAttribute('data-tags') || '').indexOf('bestseller') > -1 && li.getAttribute('data-bundle') === 'true';
          });
          var rest = original.filter(function (li) { return tops.indexOf(li) === -1; });
          tops.concat(rest).forEach(function (li) { grid.appendChild(li); });
        } else {
          original.forEach(function (li) { grid.appendChild(li); });
        }
        items.forEach(function (li) {
          var tags = li.getAttribute('data-tags') || '';
          var isBundle = li.getAttribute('data-bundle') === 'true';
          var show =
            f === 'all' ||
            (f === 'single' && !isBundle) ||
            (f === 'bundles' && isBundle) ||
            (f === 'freeship' && li.getAttribute('data-shipsfree') === 'true') ||
            (f === 'bestsellers' && tags.indexOf('bestseller') > -1);
          li.style.display = show ? '' : 'none';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratt-table-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.ratt-band').forEach(function (band) {
    // motion: reveal on scroll-into-view
    if (band.dataset.motion === 'true' && !reduce && 'IntersectionObserver' in window) {
      band.classList.add('ratt-motion');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ratt-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      io.observe(band);
    }
    // smooth scroll CTA -> the section directly below this band
    var link = band.querySelector('[data-ratt-scroll]');
    if (link) {
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var wrap = band.closest('.shopify-section') || band;
        var next = wrap.nextElementSibling;
        if (next) { next.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratt-values-recipes"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ratt-vr').forEach(function (s) {
    var row = s.querySelector('.ratt-vr__quotes');
    if (!row) return;
    var step = function (dir) { row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: 'smooth' }); };
    var p = s.querySelector('[data-ratt-qprev]'); var n = s.querySelector('[data-ratt-qnext]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();
})();
